// extracted by mini-css-extract-plugin
module.exports = {"root":"TenantAutoStatus_root__3gEsU","root__icon":"TenantAutoStatus_root__icon__1H7QS"};